// React imports
import React from 'react';

// UI – style imports
import { WithStyles, withStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';

// local imports
import { styles } from './Identity.style';
import ID from 'components/ID';

function Identity(props: WithStyles<typeof styles>) {
    const { classes } = props;

    return (
        <Box className={classes.root}>
            <Box className={classes.textContainer}>
                <Box id="titleContainer">
                    <p className="title">ES</p>
                    <p className="title" id="bot">
                        PARA
                    </p>
                    <p className="title" id="bot">
                        TODOS,
                    </p>
                    <p id="sub">abre tu cuenta en Cuenca</p>
                </Box>

                <p id="explanation">
                    Obtener una cuenta en Cuenca es muy sencillo.{' '}
                    <strong>Las personas físicas pueden registrarse directamente desde la aplicación,</strong> mientras
                    que <strong>las personas morales pueden iniciar su proceso de alta con nuestro equipo.</strong>
                    <br />
                    <br />
                    Para las personas físicas, se requiere una identificación oficial vigente. Para las personas
                    morales, será necesario proporcionar la documentación de la empresa y de su representante o
                    apoderado legal, así como completar las validaciones correspondientes.
                    <br />
                    <br />
                    <strong>
                        El proceso y la documentación requerida pueden variar según el tipo de cliente y las
                        características de la cuenta.
                    </strong>
                </p>
            </Box>

            <Box id="idContainer">
                <Box className="smallMarginRight">
                    <ID type="ine" orientation="right" />
                </Box>
                <Box className="bigMarginRight">
                    <ID type="pasaporte" orientation="left" />
                </Box>
                <Box className="smallMarginRight">
                    <ID type="residencia" orientation="right" />
                </Box>
            </Box>
        </Box>
    );
}

export default withStyles(styles)(Identity);
